//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 위험성평가 - 위험성평가표 (RIS_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 위험정보 조사표 인쇄 함수 (PrintLogic1) - 상단 인쇄 버튼 클릭 시
export const PrintLogic1 = async (_value1, dispatch, setLoading, searchRef) => {
  setLoading(true);
  let headerData = {
    custNm:
      searchRef?.current?.custList?.filter(
        (e) => e.value === searchRef?.current?.custCd
      )[0]?.custNm || '',
  };

  try {
    const printData = {
      FileName: 'BOCB0000',
      headerData: headerData,
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

// 위험정보 조사표 인쇄 함수 (PrintLogic3) - printItem 클릭 시
export const PrintLogic3 = async (documentData, dispatch, setLoading) => {
  if (!documentData) {
    console.error('PrintLogic3: documentData가 없습니다.');
    return null;
  }

  setLoading(true);
  try {
    const safetyData = await apiRequest(
      'post',
      Global.urls.DocsManagement.getRisBasic01R2,
      {
        RsCd: Commons.EncryptAES(documentData.rsCd),
      }
    );

    if (!safetyData) {
      dispatch(
        showSnackbar({
          message: '데이터 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return null;
    }

    // HeaderData 구성
    const headerData = {
      RS_CD: documentData.rsCd || '',
      RS_NM: documentData.rsNm || '',
      RS_GUBUN: documentData.rsGubun || '',
      RS_METHOD: documentData.rsMethod || '',
      RS_DATE: documentData.rsDate
        ? dayjs(documentData.rsDate).format('YYYY-MM-DD')
        : '',
      RS_MEMBER: documentData.rsMember || '',
      CUST_CD: documentData.custCd || '',
      DEP_CD: documentData.depCd || '',
      DEP_NM: documentData.depNm || '',
      WORK_TYPE: documentData.workType || '',
      PRODUCT: documentData.product || '',
      WORKER_COUNT: documentData.workerCount || '',
      RAW_MATERIAL:
        documentData.rawMaterial || documentData.rawMaterials || '',
      OTHER_SAFETY_INFORMATION: documentData.otherSafetyInformation || '',
    };

    // TableData 구성
    // TableData1: Processes (공정) - GONGJONG_NM 추출
    const processNames = (safetyData.processes || [])
      .map((p) => p.gongJongNm)
      .filter(Boolean)
      .join(' → ');

    // Kendo Report는 배열을 요구하므로 하나의 row로 감싸기
    const tableData1 = [
      {
        PROCESS_NAMES: processNames, // 필드명은 보고서에서 맞춰 사용
      },
    ];

    const printData = {
      FileName: 'RIS_BASIC_01_1', // 위험정보 조사표 레포트 파일명
      HeaderData: JSON.stringify(headerData),
      TableData1: JSON.stringify(tableData1),
      TableData2: JSON.stringify([]),
      TableData3: JSON.stringify([]),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic3: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};
